export const blockIconsHomeSensorDoor = (
	<span className='material-symbols-outlined'>sensor_door</span>
);
